import { Select } from 'components/v2/Select'
import { OperationalCostVehicleType } from 'gql/generated/graphql'
import { ReactElement } from 'react'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'

const messages = defineMessages({
  selectType: {
    id: 'vehicles.filters.type.selectType',
    defaultMessage: 'Select type'
  }
})
const VEHICLE_TYPES_LIST = [
  OperationalCostVehicleType.Sedan,
  OperationalCostVehicleType.Suv,
  OperationalCostVehicleType.Van,
  OperationalCostVehicleType.Bus
]

export const SelectVehicleType = ({
  onChange,
  value,
  errors,
  touched
}: {
  onChange: (value: OperationalCostVehicleType | '') => void
  errors?: string
  touched?: boolean
  value: string
}): ReactElement => {
  const intl = useIntl()
  return (
    <Select
      errors={errors}
      touched={touched}
      id="type"
      value={value}
      onChange={({ target: { value } }): void => {
        onChange(value as OperationalCostVehicleType | '')
      }}
      label={<FormattedMessage id="vehicles.select.type.label" defaultMessage="Vehicle Type" />}
    >
      <option value="">{intl.formatMessage(messages.selectType)}</option>
      {VEHICLE_TYPES_LIST.map((type) => (
        <option key={type} value={type}>
          {type}
        </option>
      ))}
    </Select>
  )
}
